var map = {
	"./Ansar.svg": "8326",
	"./Ayandeh.svg": "d4d0",
	"./Bank_Markazi.svg": "9071",
	"./Caspian.svg": "cf41",
	"./Dey.svg": "8739",
	"./Eghtesad_Novin.svg": "b134",
	"./Futurebank.svg": "2949",
	"./Gardeshgari.svg": "0272",
	"./Ghavamin.svg": "ada6",
	"./Hekmat.svg": "de00",
	"./Iran_Europe.svg": "a4b4",
	"./Iran_Venezuela.svg": "e33a",
	"./Iran_Zamin.svg": "a513",
	"./Karafarin.svg": "6ef7",
	"./Keshavarzi.svg": "5054",
	"./Khavar_Mianeh.svg": "94a8",
	"./Kosar.svg": "7d6e",
	"./Maskan.svg": "7257",
	"./Mehr_Eghtesad.svg": "7226",
	"./Mehr_Iran.svg": "dcd7",
	"./Melall.svg": "fdb6",
	"./Mellat.svg": "7c1c",
	"./Melli.svg": "1890",
	"./Noor.svg": "8a36",
	"./Parsian.svg": "6e45",
	"./Pasargad.svg": "4339",
	"./Postbank.svg": "138f",
	"./Refah.svg": "ff1f",
	"./Resalat.svg": "106b",
	"./Saderat.svg": "7c1d",
	"./Saman.svg": "9ecb",
	"./Sanat_Madan.svg": "a291",
	"./Sarmayeh.svg": "ee89",
	"./Sepah.svg": "7fdc",
	"./Shahr.svg": "bdca",
	"./Sina.svg": "336d",
	"./Standard_Chartered.svg": "35f6",
	"./Taavon_Eslami.svg": "9026",
	"./Tejarat.svg": "6a11",
	"./Tosee.svg": "a0a7",
	"./Tosee_Saderat.svg": "2078",
	"./Tosee_Taavon.svg": "8f91"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2db6";